import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Icon1 from "../../icons/Icon";
import SmallSpinner from "../../loading/SmallSpinner";
import Tippy from "@tippyjs/react";
import { EasySwitch } from "../../textfields/EasySwitch";

const FolderAccessTable = ({
  documents,
  persons,
  access,
  handleSaveAccess,
  setAccess,
  handleResetAccess,
  loading,
  handlesetAllAccess,
}) => {
  // Handle the toggle for each access switch
  const handleToggle = (docIndex, personIndex) => {
    setAccess(docIndex, personIndex);
  };

  return (
    <div className="text-h3 border-1 border-x-shadow_10 rounded-xl p-2">
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 font-semibold">
          <div className="flex flex-row min-w-c300 w-c300">
            <div className="flex flex-row gap-2 text-h3 items-center">
              Documents
            </div>{" "}
          </div>
          <div className="flex flex-row w-full">
            {persons.map((person, index) => (
              <div key={index} className="w-full ">
                <div className="flex flex-row gap-1 items-center justify-end">
                  {person}{" "}
                  <div className="cursor-pointer hover:bg-primary_l2 p-0.5 rounded-full ">
                    <EasySwitch
                      checked={
                        // all access for this person
                        access &&
                        access.every((doc) => doc[index]) &&
                        // all access for this person
                        access.every((doc) => doc[index] === access[0][index])
                      }
                      disabled={loading === "all"}
                      onChange={(value) => handlesetAllAccess(value, index)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-1">
          {documents.map((document, docIndex) => (
            <div className="flex flex-row hover:bg-slate-50" key={docIndex}>
              <div className="flex w-c300 min-w-c300">{document}</div>
              {persons.map((_, personIndex) => (
                <div
                  className="w-full flex flex-row justify-end"
                  key={personIndex}
                >
                  <div className="w-full flex flex-row justify-end">
                    <Tippy
                      content={
                        access && access[docIndex][personIndex]
                          ? "Accès donné"
                          : "Accès retiré"
                      }
                      className="custom-tooltip"
                      delay={500}
                    >
                      <div>
                        <EasySwitch
                          checked={access && access[docIndex][personIndex]}
                          disabled={
                            loading === "all" ||
                            loading === persons[personIndex] ||
                            persons[personIndex] === "Particulier"
                          }
                          onChange={() => handleToggle(docIndex, personIndex)}
                        />
                      </div>
                    </Tippy>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FolderAccessTable;
